import { render } from "./ChangeBeforeAfter.vue?vue&type=template&id=2372234b&scoped=true"
import script from "./ChangeBeforeAfter.vue?vue&type=script&lang=js"
export * from "./ChangeBeforeAfter.vue?vue&type=script&lang=js"

import "./ChangeBeforeAfter.vue?vue&type=style&index=0&id=2372234b&lang=scss&scoped=true"

import exportComponent from "/opt/anthos/FBL_OTWS/OTWS_src5/otws-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2372234b"]])

export default __exports__